import { Link } from 'react-router-dom';
import { Compass, ShieldAlert } from 'lucide-react';

import { StateCard } from '@/ui/StateCard';

export function NotFound() {
  return (
    <StateCard icon={<Compass aria-hidden="true" />} title="Page not found">
      <p>There is nothing at this address.</p>
      <p className="empty-actions">
        <Link to="/dashboard" className="btn btn-secondary">
          Go to the dashboard
        </Link>
      </p>
    </StateCard>
  );
}

/** Rendered in place when the server did not grant this screen's navigation key. */
export function NotAvailable() {
  return (
    <StateCard warning icon={<ShieldAlert aria-hidden="true" />} title="Not available to you">
      <p>This screen is restricted to administrators. The server refuses its data to anyone else.</p>
    </StateCard>
  );
}
